export const generateFilterLabel = (label, count) => `${label} (${count})`;

export const filterCount = (locationFilters, displayedLocations) =>
  locationFilters.map(filter => {
    const item = filter;
    item.count = 0;
    displayedLocations.forEach(location => {
      item.count = location.tags.includes(filter.key)
        ? filter.count + 1
        : filter.count;
    });
    return item;
  });

export const parseLocationItems = items =>
  items.map((item, index) => ({ ...item, id: `${index}` }));
